import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { EServiceTemplateLegalBasis, EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField, isServiceAllFieldsByCdnState } from "@devowl-wp/api-real-cookie-banner";
import { useServiceCdnState } from "../../../../../../hooks/service/useServiceCdnState.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper, FormFieldVisibilityWrapperByCdn } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
/**
 * Form field for the legal basis of the service template.
 */ function FormFieldServiceTemplateLegalBasis() {
    const { t } = useTranslation();
    const legalOptions = useMemo(()=>[
            {
                label: t("Not set"),
                value: null,
                style: {
                    marginRight: "1rem"
                }
            },
            {
                label: t("Consent (Opt-in)"),
                value: EServiceTemplateLegalBasis.Consent
            },
            {
                label: t("Legitimate interest (Opt-out)"),
                value: EServiceTemplateLegalBasis.LegitimateInterest
            },
            {
                label: t("Compliance with a legal obligation"),
                value: EServiceTemplateLegalBasis.LegalRequirement
            }
        ], []);
    const cdnFieldState = useServiceCdnState(ServiceTemplateField.LegalBasis);
    const isFormFullyVisible = useMemo(()=>isServiceAllFieldsByCdnState(cdnFieldState), [
        cdnFieldState
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapperByCdn, {
        children: /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
            fieldNames: ServiceTemplateField.LegalBasis,
            permissionCheck: {
                whenRole: EUserRole.Translator,
                roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
            },
            children: /*#__PURE__*/ _jsx(Form.Item, {
                label: getFieldNameTranslated(ServiceTemplateField.LegalBasis, t),
                rules: [
                    {
                        required: isFormFullyVisible,
                        message: t("Please define a legal basis for this service template.")
                    }
                ],
                shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                required: true,
                children: ({ getFieldValue })=>{
                    const extended = getFieldValue(TemplateMetaDataField.Extends);
                    return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ServiceTemplateField.LegalBasis,
                        disableStrategies: getDisableStrategies(),
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Radio.Group, {
                            options: legalOptions,
                            optionType: "button",
                            buttonStyle: "solid",
                            defaultValue: extended[ServiceTemplateField.LegalBasis],
                            disabled: true
                        }),
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: ServiceTemplateField.LegalBasis,
                            noStyle: true,
                            required: true,
                            children: /*#__PURE__*/ _jsx(Radio.Group, {
                                options: legalOptions,
                                optionType: "button",
                                buttonStyle: "solid",
                                disabled: cdnFieldState === "enabledWithStandardClauses"
                            })
                        })
                    });
                }
            })
        })
    });
}
export { FormFieldServiceTemplateLegalBasis };
